<template>
  <div class="title-bar-comp">
    <cs-icon-button v-if="back" icon="i-back" @click="$router.back()" />
    <h1 class="bold">{{ title }}</h1>
    <div class="center" v-if="showCenter"><slot name="center" /></div>
    <slot />
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component, Prop } from 'kuaidong-component'
import CsIconButton from '@/components/CsIconButton.vue'

@Component({ components: { CsIconButton } })
export default class TitleBar extends BaseComponent {
  @Prop(Boolean)
  back!: boolean

  @Prop(String)
  title!: string

  @Prop({ type: Boolean, default: true })
  showCenter!: boolean
}
</script>
<style lang="less">
.title-bar-comp {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 30px;

  .cs-icon-button .i-back {
    font-size: 24px;
    color: #2981f8;
  }
  .center {
    flex-grow: 1;
  }

  .el-input {
    width: 400px;
    input {
      border-radius: 20px;
    }
  }
}
</style>
